module.exports = __webpack_public_path__ + "res/roboto-v15-latin-500italic.woff2";


//////////////////
// WEBPACK FOOTER
// ./client/app/vendor/googlefonts/roboto-v15-latin-500italic.woff2
// module id = 102
// module chunks = 1